import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { API, setPacienteToken } from '../../services/pacienteConfig';
import brandIcon from '../../assets/brand/icon.png';
import './PacienteLoginPage.css';

const PacienteLoginPage = () => {
  const [dni, setDni] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setError(null);
    setLoading(true);

    try {
      const response = await fetch(`${API}/paciente/login`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        },
        body: JSON.stringify({ dni, password }),
      });

      const data = await response.json();

      if (response.ok && data.success) {
        setPacienteToken(data.token);
        localStorage.setItem('paciente_user', JSON.stringify(data.paciente));
        
        if (data.must_change_password) {
          navigate('/paciente/cambiar-password');
        } else {
          navigate('/paciente');
        }
      } else {
        setError(data.error || 'DNI o contraseña incorrectos.');
      }
    } catch (err) {
      setError('Error de conexión. Intente nuevamente.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="paciente-login-page">
      <div className="login-card">
        <div className="login-header">
          <img
            src={brandIcon}
            alt="TurnoOnline"
            className="login-logo"
          />
          <h2>Portal del Paciente</h2>
          <p>Ingresa para gestionar tu salud</p>
        </div>

        {error && <div className="login-error">{error}</div>}

        <form onSubmit={handleLogin} className="login-form">
          <div className="form-group">
            <label htmlFor="dni">DNI</label>
            <input
              id="dni"
              type="text"
              inputMode="numeric"
              placeholder="Ingresa tu DNI"
              value={dni}
              onChange={(e) => setDni(e.target.value)}
              required
              autoComplete="username"
            />
          </div>

          <div className="form-group">
            <label htmlFor="password">Contrasena</label>
            <div className="password-input-wrapper">
              <input
                id="password"
                type={showPassword ? 'text' : 'password'}
                placeholder="Ingresa tu contrasena"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                autoComplete="current-password"
              />
              <button
                type="button"
                className="toggle-password"
                onClick={() => setShowPassword(!showPassword)}
                aria-label={showPassword ? 'Ocultar contrasena' : 'Mostrar contrasena'}
              >
                {showPassword ? 'Ocultar' : 'Ver'}
              </button>
            </div>
          </div>

          <button type="submit" className="login-button" disabled={loading}>
            {loading ? 'Ingresando...' : 'Ingresar'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default PacienteLoginPage;
